import React from 'react';
import cx from 'classnames';
import './Button.css';
import { Link } from 'react-router-dom';

export const Button = ({ to, text, loading, classNames, ...props }) => {
    const classes = cx(classNames, 'button', {
        'loading': loading
    });

    const Btn = () => <button {...props} className={classes}>{text}</button>;

    return to ? <Link to={to}><Btn /></Link> : <Btn />;
};


// WEBPACK FOOTER //
// ./src/components/Button.js